// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1yBoi","image":"App_image__218mA"};